import isImmutableMap from "./is-immutable-map";
import diffStyles from "./diff-styles";
export function getInteractiveLayerIds(mapStyle) {
  var interactiveLayerIds = null;
  return isImmutableMap(mapStyle) && mapStyle.has("layers") ? interactiveLayerIds = mapStyle.get("layers").filter(function (l) {
    return l.get("interactive");
  }).map(function (l) {
    return l.get("id");
  }).toJS() : Array.isArray(mapStyle.layers) && (interactiveLayerIds = mapStyle.layers.filter(function (l) {
    return l.interactive;
  }).map(function (l) {
    return l.id;
  })), interactiveLayerIds;
}
export function setDiffStyle(prevStyle, nextStyle, map) {
  function styleKeysMap(style) {
    return style.map(function () {
      return !0;
    }).delete("layers").delete("sources").toJS();
  }

  var prevKeysMap = prevStyle && styleKeysMap(prevStyle) || {},
      nextKeysMap = styleKeysMap(nextStyle);
  if (!prevStyle || function () {
    var prevKeysList = Object.keys(prevKeysMap),
        nextKeysList = Object.keys(nextKeysMap);
    return prevKeysList.length !== nextKeysList.length || !!nextKeysList.some(function (key) {
      return prevStyle.get(key) !== nextStyle.get(key);
    });
  }()) return void map.setStyle(nextStyle.toJS());

  var _diffStyles = diffStyles(prevStyle, nextStyle),
      sourcesDiff = _diffStyles.sourcesDiff,
      layersDiff = _diffStyles.layersDiff;

  checkForEqualLayerSourceChanges(sourcesDiff.exit, nextStyle.get("layers")), applySourceLayerChanges(map, nextStyle, sourcesDiff, layersDiff);
}

function updateStyleSource(map, update) {
  var newSource = update.source.toJS();

  if ("geojson" === newSource.type) {
    var oldSource = map.getSource(update.id);

    if ("geojson" === oldSource.type) {
      var oldOpts = oldSource.workerOptions,
          scale = oldOpts.geojsonVtOptions.extent / 512;
      if ((void 0 === newSource.maxzoom || newSource.maxzoom === oldOpts.geojsonVtOptions.maxZoom) && (void 0 === newSource.buffer || newSource.buffer === oldOpts.geojsonVtOptions.buffer / scale) && (void 0 === newSource.tolerance || newSource.tolerance === oldOpts.geojsonVtOptions.tolerance / scale) && (void 0 === newSource.cluster || newSource.cluster === oldOpts.cluster) && (void 0 === newSource.clusterRadius || newSource.clusterRadius === oldOpts.superclusterOptions.radius / scale) && (void 0 === newSource.clusterMaxZoom || newSource.clusterMaxZoom === oldOpts.superclusterOptions.maxZoom)) return void oldSource.setData(newSource.data);
    }
  }

  map.removeSource(update.id), map.addSource(update.id, newSource);
}

function applySourceLayerChanges(map, nextStyle, sourcesDiff, layersDiff) {
  if (layersDiff.updates.some(function (node) {
    return node.layer.get("ref");
  })) return void map.setStyle(nextStyle.toJS());

  var _iteratorNormalCompletion = !0,
      _didIteratorError = !1,
      _iteratorError = void 0;

  try {
    for (var _step, enter, _iterator = sourcesDiff.enter[Symbol.iterator](); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = !0) {
      enter = _step.value, map.addSource(enter.id, enter.source.toJS());
    }
  } catch (err) {
    _didIteratorError = !0, _iteratorError = err;
  } finally {
    try {
      _iteratorNormalCompletion || null == _iterator.return || _iterator.return();
    } finally {
      if (_didIteratorError) throw _iteratorError;
    }
  }

  var _iteratorNormalCompletion2 = !0,
      _didIteratorError2 = !1,
      _iteratorError2 = void 0;

  try {
    for (var _step2, update, _iterator2 = sourcesDiff.update[Symbol.iterator](); !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = !0) {
      update = _step2.value, updateStyleSource(map, update);
    }
  } catch (err) {
    _didIteratorError2 = !0, _iteratorError2 = err;
  } finally {
    try {
      _iteratorNormalCompletion2 || null == _iterator2.return || _iterator2.return();
    } finally {
      if (_didIteratorError2) throw _iteratorError2;
    }
  }

  var _iteratorNormalCompletion3 = !0,
      _didIteratorError3 = !1,
      _iteratorError3 = void 0;

  try {
    for (var _step3, exit, _iterator3 = layersDiff.exiting[Symbol.iterator](); !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = !0) {
      exit = _step3.value, map.style.getLayer(exit.id) && map.removeLayer(exit.id);
    }
  } catch (err) {
    _didIteratorError3 = !0, _iteratorError3 = err;
  } finally {
    try {
      _iteratorNormalCompletion3 || null == _iterator3.return || _iterator3.return();
    } finally {
      if (_didIteratorError3) throw _iteratorError3;
    }
  }

  var _iteratorNormalCompletion4 = !0,
      _didIteratorError4 = !1,
      _iteratorError4 = void 0;

  try {
    for (var _step4, _update, _iterator4 = layersDiff.updates[Symbol.iterator](); !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = !0) {
      _update = _step4.value, _update.enter || map.removeLayer(_update.id), map.addLayer(_update.layer.toJS(), _update.before);
    }
  } catch (err) {
    _didIteratorError4 = !0, _iteratorError4 = err;
  } finally {
    try {
      _iteratorNormalCompletion4 || null == _iterator4.return || _iterator4.return();
    } finally {
      if (_didIteratorError4) throw _iteratorError4;
    }
  }

  var _iteratorNormalCompletion5 = !0,
      _didIteratorError5 = !1,
      _iteratorError5 = void 0;

  try {
    for (var _step5, _exit, _iterator5 = sourcesDiff.exit[Symbol.iterator](); !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = !0) {
      _exit = _step5.value, map.removeSource(_exit.id);
    }
  } catch (err) {
    _didIteratorError5 = !0, _iteratorError5 = err;
  } finally {
    try {
      _iteratorNormalCompletion5 || null == _iterator5.return || _iterator5.return();
    } finally {
      if (_didIteratorError5) throw _iteratorError5;
    }
  }
}

function checkForEqualLayerSourceChanges(sourceExit, nextLayers) {
  var sourceIds = sourceExit.map(function (s) {
    return s.id;
  }),
      layersNotRemoved = nextLayers.filter(function (lyr) {
    return sourceIds.includes(lyr.get("source"));
  });
  if (layersNotRemoved.size) throw new Error("You must remove any layers associated with sources you are removing: ".concat(layersNotRemoved.map(function (l) {
    return l.get("id");
  }).toJS().join("")));
}